/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import withPermissions from '@modules/permissions-components/PermissionsGate/withPermissions'
import Feature from '@modules/utils/feature'

import { getAccountDetails } from '@/apps/userconsole/reducers/account'
import { fetchAccountDetailsIfNeeded } from '@/apps/userconsole/actions/account'
import { isFeatureActivated } from '@/selectors'

import UserAuthentication from './UserAuthentication'

import type { ConsumerProps, DispatchProps, StateProps } from './types'

const mapStateToProps = (state, ownProps) => {
  const organizationId = ownProps.organizationId
  const enforceAuthenticationMethod =
    state.organizations.organizations[organizationId]?.enforce_authentication_method
  return {
    enforceAuthenticationMethod,
    accountDetails: getAccountDetails(state),
    enableUsageNoticeElasticCheck: isFeatureActivated(state, Feature.enableUsageNoticeElasticCheck),
  }
}

const mapDispatchToProps: DispatchProps = {
  fetchAccountDetails: fetchAccountDetailsIfNeeded,
}

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(
  withPermissions({
    hasViewOrganizationIdp: {
      permissionsToCheck: [
        {
          type: 'organization-idp',
          action: 'get',
        },
      ],
    },
    hasUpdateOrganizationIdp: {
      permissionsToCheck: [
        {
          type: 'organization-idp',
          action: 'update',
        },
      ],
    },
    hasListFeatureUsage: {
      permissionsToCheck: [
        {
          type: 'feature-usage',
          action: 'list',
        },
      ],
    },
  })(UserAuthentication),
)
